module.exports = __webpack_public_path__ + "static/img/MickMcGuane.50d0b05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MickMcGuane.jpg
// module id = vmvA
// module chunks = 0